import LoadingWheel from './LoadingWheel';

export default LoadingWheel;
